export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/acZCT2PtJXcdFTkoXpGcLu/PAGINA_1.png',
    alt: "Pagina di esempio Dall'organismo alla biosfera: i livelli di organizzazione ecologica rappresentati come una scala",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5cTSabpUbPuqyHNy5y6Rgn/PAGINA_2.png',
    alt: "Pagina di esempio La natura ricicla tutto: i cicli biogeochimici dell'acqua, del carbonio, dell'azoto e del fosforo",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aRabvgH3GXMEjCrPtPV6RZ/PAGINA_3.png',
    alt: "Pagina di esempio Quanta natura usiamo? L'impronta ecologica a confronto con la biocapacità",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vhCy5Kkge923SKSzvni1ZH/PAGINA_4.png',
    alt: 'Pagina di esempio La scuola è un piccolo sistema ambientale: gli aspetti ambientali di un edificio scolastico',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3K1GHRQR5auraVDuLWFaWp/PAGINA_5.png',
    alt: 'Pagina di esempio Caso pratico: il fiume di due comuni, gestire una risorsa condivisa',
  },
];
